export default class UIModelView {
    constructor() {
        this.width = 800
        this.height = 1000
        this.orientation = 'H'
        this.isMobile = false
        this.positionStage =  {x:0, y: 0}
    }

    setParams(data){
        this.width = data.width
        this.height = data.height
        this.isMobile = data.isMobile
        this.orientation = data.orientation
        this.scale = data.scale
        this.safeZone = data.safeZone
        this.positionStage = data.positionStage
    }

    get shiftY(){
        return this.positionStage.y/this.scale
    }

    get shiftX(){
        return this.positionStage.x/this.scale
    }

    get shiftHeight(){
        return this.height/this.scale
    }

    get shiftWidth(){
        return this.width*this.scale
    }

    get widthScreen(){
        const shifhx =  this.shiftX > -100 ? -100 : this.shiftX   // black frame
        return 2800 + 2*shifhx
        //this.safeZone.width/this.scale //width2
    }
}